const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const SalesExecutive = 'SalesExecutive'
const Financial = "Financial"
const Logistics = 'Logistics'
const Seller = 'Seller'
const CreditAnalyst = 'CreditAnalyst'

export default [
  {
    path: '/pallets',
    name: 'Pallets',
    component: () => import('@/_backoffice/_registrations/components/pallets/Pallets.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
  },
]